import { CardHeader as CardHeaderMui } from "@mui/material";
import BotaoVoltar from "../botao-voltar/botao-voltar.component";
import Grid from "../grid/grid.component";
import UsuarioLog from "../usuario-log/usuario-log.component";

const CardHeader = ({
  action,
  filterActions,
  avatar,
  classes,
  className,
  component,
  disableTypography,
  subheader,
  subheaderTypographyProps,
  titleAlign,
  sx,
  title,
  titleTypographyProps,
  botaoVoltar,
  onClickVoltar,
  userLog,
  onClickLog,
  ...other
}) => {
  return (
    <CardHeaderMui
      action={action}
      avatar={avatar}
      component={component}
      disableTypography={disableTypography ? true : false}
      subheader={subheader}
      subheaderTypographyProps={subheaderTypographyProps}
      classes={classes}
      className={className}
      sx={{
        padding: "16px !important",
        margin: "0 !important",
        ...sx,
      }}
      title={
        <Grid container alignItems="center" justifyContent={titleAlign}>
          {botaoVoltar && <BotaoVoltar onClickVoltar={onClickVoltar} />}
          {title}
          {userLog && onClickLog ? (
            <UsuarioLog
              createDate={userLog?.createdAt}
              editDate={userLog?.updatedAt}
              userCreatedLog={userLog?.userCreatedLog}
              userEditedLog={userLog?.userEditedLog}
              onClickLog={onClickLog}
            />
          ) : null}
          {filterActions}
        </Grid>
      }
      titleTypographyProps={titleTypographyProps}
      {...other}
    ></CardHeaderMui>
  );
};

export default CardHeader;
